import SigliveServiceV1 from 'Service/sigliveServiceV1';

const getGenerateSchedule = async (body) => {
  const { data } = await SigliveServiceV1({ method: 'POST', url: `/schedule/generate`, data: body });

  return data?.data;
};

export default getGenerateSchedule;
